import React, { useState } from "react";
import { Link } from "react-router-dom"; // Use Link from react-router-dom for routing
import "../styles/Navbar.css";
import logo from "../assets/Guch.jpg"; // Ensure the logo path is correct

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="navbar">
      <div className="navbar-logo">
        <img src={logo} alt="GÜÇH DOORS Logo" className="logo-image" />
        <span className="brand-name">GÜÇH DOORS</span>
      </div>

      {/* Hamburger Menu Button */}
      <div className="hamburger-menu" onClick={toggleMenu}>
        <div className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></div>
        <div className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></div>
        <div className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></div>
      </div>

      {/* Navigation Links */}
      <nav className={`navbar-links ${isMenuOpen ? "open" : ""}`}>
        <a href="#about" onClick={closeMenu}>
          About Us
        </a>
        <a href="#products" onClick={closeMenu}>
          Products
        </a>
        <a href="#features" onClick={closeMenu}>
          Features
        </a>
        <a href="#quality-promise" onClick={closeMenu}>
          Our Promise
        </a>
        <a href="#contact" onClick={closeMenu}>
          Contact
        </a>
        <Link to="/catalog" onClick={closeMenu}>
          Catalog
        </Link>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div
          className={`mobile-menu-overlay ${isMenuOpen ? "open" : ""}`}
          onClick={closeMenu}
        ></div>
      )}
    </header>
  );
};

export default Navbar;
